import { Component, OnInit } from '@angular/core';
import { ColumnType, DataTableColumn, DataTableRow } from '../../controls/datatable/datatable.component';
import { ModalConfig } from '../../controls/modal/modal-config';
import { ModalRef } from '../../controls/modal/modal-ref';

@Component({
    selector: 'app-product-resync',
    templateUrl: './product-resync.component.html',
    styleUrls: ['./product-resync.component.css'],
    standalone: false
})
export class ProductResyncComponent implements OnInit {

  cols:DataTableColumn[] = [new DataTableColumn("system", "System", ColumnType.STRING, true, "25"),
    new DataTableColumn("installPath", "Install path", ColumnType.STRING, false, "25"),
    new DataTableColumn("message", "Message", ColumnType.STRING, false, "50")];
  rows:DataTableRow[] = [];
  id:string;
  title:string;
  message:string;

  constructor(private modalRef: ModalRef,
    private modalConfig: ModalConfig,) { 

    }

  ngOnInit(): void {
    this.rows = this.modalConfig.data.rows;
    this.title = this.modalConfig.data.title;
    this.id = this.modalConfig.data.id;
    this.message = this.modalConfig.data.message;
  }

  close(): void {
    this.modalRef.close(false);
  }

}
